import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo, faDatabase, faListOl, faSquareCheck } from '@fortawesome/free-solid-svg-icons'

export default function PageData({ data }) {
  return (
    <div>
      <h2 className='text-xl mb-4 font-bold text-slate-700 lg:mb-5 lg:text-3xl'>
        <FontAwesomeIcon icon={faSquareCheck} className='mt-0.5 mr-3 text-blue-400' />
        데이터 보유 현황
      </h2>

      <div className='flex flex-col gap-10'>
        {data.map((item, index) => (
          <div className='flex flex-col gap-3 text-gray-700 lg:flex-row lg:gap-10' key={index}>
            {/* 데이터 종류 */}
            <div className='inset-content-box w-full p-8 rounded-xl lg:w-1/3 lg:p-12'>
              <FontAwesomeIcon icon={faDatabase} className='mr-3 text-yellow-400' size='xl' />
              <span className='inline-block mb-4 font-bold text-lg lg:block lg:mt-3 lg:mb-5 lg:text-xl'>
                데이터 종류
              </span>
              <span className='block leading-8 text-sm'>{item.dataType}</span>
            </div>

            {/* 데이터 개수 */}
            <div className='inset-content-box w-full p-8 rounded-xl lg:w-1/3 lg:p-12'>
              <FontAwesomeIcon icon={faListOl} className='mr-3 text-cyan-500' size='xl' />
              <span className='inline-block mb-4 font-bold text-lg lg:block lg:mt-3 lg:mb-5 lg:text-xl'>
                데이터 개수
              </span>
              <span className='block leading-8 text-sm'>{item.dataCount}</span>
            </div>

            {/* 데이터 상세 내용 */}
            <div className='inset-content-box w-full p-8 rounded-xl lg:w-1/3 lg:p-12'>
              <ul>
                <FontAwesomeIcon icon={faCircleInfo} className='mr-3 text-indigo-500' size='xl' />
                <span className='inline-block mb-4 font-bold text-lg lg:block lg:mt-3 lg:mb-5 lg:text-xl'>
                  데이터 상세 내용
                </span>
                {item.dataDetail.map((detail, index) => (
                  <li className='leading-8 text-sm' key={index}>
                    {detail}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
